import {IconConfig} from "./icon.model";

export const iconsSettings: IconConfig[] = [
  {
    name: 'envelope',
    path: 'assets/img/mat-icons/settings/envelope.svg',
  }
]
